import React, { useState, useContext, FC, useEffect } from "react";
import {
  NewBox as Box,
  NewIcon as Icon,
  NewList as List,
  NewNonModal as NonModal,
  NewTypography as Typography,
} from "@bca/ui-library";
import { useRouter } from "next/router";
import { useDeleteSavedSearches } from "../../hooks/useDeleteSavedSearches";
import ConfirmationModal from "../../components/ConfirmationModal";
import { ErrorContext } from "../../context/ErrorContext";
interface NonModalWithStateProps {
  data: { id: string };
  isLastElement?: boolean;
  isMobile?: boolean;
}
const NonModalWithState: FC<NonModalWithStateProps> = ({
  data,
  isLastElement,
  isMobile,
}) => {
  const errorContext = useContext(ErrorContext);

  const router = useRouter();
  const { query } = router;

  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState([]);
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);

  useDeleteSavedSearches(id, setId, query);

  const handleDeleteSavedSearch = () => {
    setId([data.id]);
    router.reload();
    setShowConfirmationModal(false);
  };

  const handleEditSavedSearch = (event) => {
    event.stopPropagation();
    window.location.href = `/search/StockAlerts?id=${data.id}`;
  };

  useEffect(() => {
    if (
      errorContext?.state.somethingWentWrong &&
      errorContext?.state.type === "delete-saved-searches"
    ) {
      setShowConfirmationModal(false);
    }
  }, [errorContext]);

  const handleElementClick = (event) => {
    event.stopPropagation();
    setIsOpen(!isOpen);
  };

  return (
    <>
      <ConfirmationModal
        showConfirmationModal={showConfirmationModal}
        setShowConfirmationModal={setShowConfirmationModal}
        modalAction={handleDeleteSavedSearch}
        actionTitle="delete"
      />
      <NonModal
        className="non-modal"
        data-nonmodal-id={data.id}
        open={isOpen}
        onOutsideClick={() => setIsOpen(false)}
        renderActionElement={() => (
          <Box padding={isMobile ? "sm" : null}>
            <Icon name="elipses" size="md" onClick={handleElementClick} />
          </Box>
        )}
        width="auto"
        position={isLastElement ? "top-left" : "bottom-left"}
        padding="xxs"
        borderRadius="md"
      >
        <Box>
          <List
            direction="column"
            paddingRight="md"
            alignSelf="center"
            width="132px"
          >
            <List.Item.Selectable
              onClick={handleEditSavedSearch}
              padding="xs"
              borderRadius="md"
              height="sm"
            >
              <Icon
                name="edit"
                color="dark_3"
                marginLeft="xs"
                marginRight="0"
              />
              <Typography color="fg_dark_3" weight="heavy">
                Edit
              </Typography>
            </List.Item.Selectable>
            <List.Item.Selectable
              onClick={(event) => {
                event.stopPropagation();
                setShowConfirmationModal(true);
              }}
              padding="xs"
              borderRadius="md"
              height="sm"
            >
              <Icon
                name="delete"
                color="dark_3"
                marginLeft="xs"
                marginRight="0"
              />
              <Typography color="fg_dark_3" weight="heavy">
                Delete
              </Typography>
            </List.Item.Selectable>
          </List>
        </Box>
      </NonModal>
    </>
  );
};

export default NonModalWithState;
